import React, {useEffect} from 'react';
import { proactiveCriteriaOptions, proactiveAttributionCriteriaOptions } from './ProactiveMetricsDetailUtil';
import { RETAIN_CAMPAIGNS } from '../RetainDashboard/Utilities/CampaignUtils';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import styles from "./Utilities/styles.module.css";

const ProactiveResponseButtons = ({
    selectedCriteria,
    setSelectedCriteria,
    setLiked,
    setReplied,
    setNoEngagement,
   setFollowed,
   setConverted,
    setFollowUpSent,
    setConvertedAfterFollowUpSent,
    setHasAdditionalOrders,
    setOrderedWithin5Days,
    setOrderedRecommendedCategory,
    setOrderedRecommendedProduct,
    setUsedDiscount,
    setUsedExactDiscountCode,
    setLastTouch,
    pageFilter
}) => {
    const criteriaOptions = pageFilter === RETAIN_CAMPAIGNS ? proactiveCriteriaOptions.retain : proactiveCriteriaOptions.acquire;
    const attributionCriteriaOptions = pageFilter === RETAIN_CAMPAIGNS ? proactiveAttributionCriteriaOptions.retain : proactiveAttributionCriteriaOptions.acquire;

    const handleCriteriaChange = (criteriaSelected, value) => {
        if (criteriaSelected) {
            setSelectedCriteria(value);
        } else {
            setSelectedCriteria(...selectedCriteria);
        }
    }

    const clearAllFilters = () => {
        setLiked(false);
        setReplied(false);
        setFollowed(false);
        setConverted(false);
        setNoEngagement(false);
        setFollowUpSent(false);
        setConvertedAfterFollowUpSent(false);
        setHasAdditionalOrders(false);
        setOrderedWithin5Days(false);
        setOrderedRecommendedCategory(false);
        setOrderedRecommendedProduct(false);
        setUsedDiscount(false);
        setUsedExactDiscountCode(false);
        setLastTouch(false);
    }

    const setters = [
        selectedCriteria,
        setLiked,
        setReplied,
        setNoEngagement,
        setFollowed,
        setConverted,
        setFollowUpSent,
        setConvertedAfterFollowUpSent,
        setHasAdditionalOrders,
        setOrderedWithin5Days,
        setOrderedRecommendedCategory,
        setOrderedRecommendedProduct,
        setUsedDiscount,
        setUsedExactDiscountCode,
        setLastTouch
    ];

    useEffect(() => {
        // This effect runs after the state has been updated.
        if (selectedCriteria === 'liked') {
            clearAllFilters();
            setLiked(true);
        } else if (selectedCriteria === 'replied') {
            clearAllFilters();
            setReplied(true);
        } else if (selectedCriteria === 'noEngagementYet') {
            clearAllFilters();
            setNoEngagement(true);
        } else if (selectedCriteria === 'all_messages') {
            clearAllFilters();
        } else if (selectedCriteria === 'followed') {
            clearAllFilters();
            setFollowed(true);
        } else if (selectedCriteria === 'converted') {
            clearAllFilters();
            setConverted(true);
        } else if (selectedCriteria === 'followUpSent') {
            clearAllFilters();
            setFollowUpSent(true);
        } else if (selectedCriteria === 'convertedAfterFollowUpSent') {
            clearAllFilters();
            setConvertedAfterFollowUpSent(true);
        } else if (selectedCriteria == 'hasAdditionalOrders') {
            clearAllFilters();
            setHasAdditionalOrders(true);
        } else if (selectedCriteria === 'orderedWithin5Days') {
            clearAllFilters();
            setOrderedWithin5Days(true);
        } else if (selectedCriteria === 'orderedRecommendedCategory') {
            clearAllFilters();
            setOrderedRecommendedCategory(true);
        } else if (selectedCriteria === 'orderedRecommendedProduct') {
            clearAllFilters();
            setOrderedRecommendedProduct(true);
        } else if (selectedCriteria === 'usedDiscount') {
            clearAllFilters();
            setUsedDiscount(true);
        } else if (selectedCriteria === 'usedExactDiscountCode') {
            clearAllFilters();
            setUsedExactDiscountCode(true);
        } else if (selectedCriteria === 'lastTouch') {
            clearAllFilters();
            setLastTouch(true);
        }
    }, setters);

    const renderCriteriaOption = (option, index) => (
        <label key={index} className="criteria-radio-label" htmlFor={option.name}
               onClick={(e) => handleCriteriaChange}>
            {option.value}
            <input
                type="radio"
                name="radio"
                value={option.name}
                id={option.name}
                onChange={(e) => handleCriteriaChange(e.target.checked, option.name)}
                checked={selectedCriteria === option.name}
            />
            <span className="radio-checkmark"/>
        </label>
    );

    return (
        <div>
            <div className="criteria-filter criteria-filter-column">
                <span className="criteria-heading">Engagement</span>
                {criteriaOptions.map((option, index) => renderCriteriaOption(option, index))}
            </div>
            {
                attributionCriteriaOptions ? (
                    <div className="criteria-filter criteria-filter-column">
                        <div className={styles.attributionHeading}>
                            <span className="criteria-heading">
                                Attribution
                            </span>
                            <a href={"https://help.beremarkable.ai/en/articles/12415870-retain-ai-attribution-metrics"} target={"_blank"} rel="noopener" className={styles.helpLink}>
                                <HelpOutlineIcon sx={{fontSize: "16px", color: "#696969"}}/>
                            </a>
                        </div>
                        {attributionCriteriaOptions.map((option, index) => renderCriteriaOption(option, index))}
                    </div>
                ) : ''
            }
        </div>
    )
}

export {ProactiveResponseButtons}